import { Fragment } from 'react/jsx-runtime'
import type { recipeIngredient } from '../../../../utils/recipeUtils'
import RecipeIngredient from './RecipeIngredient'
import NewRecipeIngredient from './NewRecipeIngredient'
import type { ingredient } from '../../../../utils/ingredientUtils'

interface RecipeIngredientListProps {
  existingIngredients: ingredient[]
  recipeIngredients: recipeIngredient[]
  setRecipeIngredients: React.Dispatch<React.SetStateAction<recipeIngredient[]>>
}

function RecipeIngredientList({
  existingIngredients,
  recipeIngredients,
  setRecipeIngredients,
}: RecipeIngredientListProps) {
  const setRecipeIngredient = (
    index: number,
    newRecipeIngredient: recipeIngredient
  ) => {
    const newIngredients = [...recipeIngredients]
    newIngredients[index] = newRecipeIngredient
    setRecipeIngredients(newIngredients)
  }

  const newRecipeIngredient = (productId: number, productName: string) => {
    const newRecipeIngredients = [...recipeIngredients]
    const newIngredient: recipeIngredient = {
      id: 0,
      productId: productId,
      productName: productName,
      quantity: 1,
      extra: null,
      new: true,
    }
    newRecipeIngredients.push(newIngredient)
    setRecipeIngredients(newRecipeIngredients)
  }

  const generateIngredients = () => {
    return recipeIngredients.reduce((current, ingredient, index) => {
      if (ingredient.deleted) return current
      current.push(
        <RecipeIngredient
          key={ingredient.id}
          index={index}
          ingredient={ingredient}
          setRecipeIngredient={setRecipeIngredient}
        />
      )
      return current
    }, [] as React.ReactNode[])
  }

  const ingredientsToShow = existingIngredients.filter(existing => {
    return !recipeIngredients.find(ri => ri.productId === existing.id)
  })
  return (
    <div className="recipe-list-container">
      {
        <Fragment>
          {generateIngredients()}
          <NewRecipeIngredient
            existingIngredients={ingredientsToShow}
            newRecipeIngredient={newRecipeIngredient}
          />
        </Fragment>
      }
    </div>
  )
}

export default RecipeIngredientList
